import { TreeNode } from "./types";

export type TreeIndex = {
  nodes: Record<
    string,
    {
      id: string;
      label: string;
      parent: string | null;
      children: string[];
    }
  >;
};

export function buildTreeIndex(
  tree: TreeNode[]
): TreeIndex {
  const nodes: TreeIndex["nodes"] = {};

  function walk(
    items: TreeNode[],
    parent: string | null
  ) {
    for (const item of items) {
      nodes[item.id] = {
        id: item.id,
        label: item.label,
        parent,
        children:
          item.children?.map((c) => c.id) || []
      };

      if (item.children) {
        walk(item.children, item.id);
      }
    }
  }

  walk(tree, null);

  return { nodes };
}